import PageHandlersService from '@/utils/page-handlers-service';

const pageHandlers = new PageHandlersService();

const init = () => {
    const header = document.querySelector<HTMLElement>('.js-header');

    header?.classList.add('header-state--back-btn');

    pageHandlers.set(
        document,
        () => {
            if (window.scrollY > 0) {
                header?.classList.remove('header-state--back-btn');
            } else {
                header?.classList.add('header-state--back-btn');
            }
        },
        'scroll',
    );
};

const destroy = () => {
    pageHandlers.clear();

    const header = document.querySelector<HTMLElement>('.js-header');
    header?.classList.remove('header-state--back-btn');
};

const _module = { init, destroy };

export default _module;
